module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"redux","commonjs2":"redux","commonjs":"redux","amd":"redux","umd":"redux"}
// module id = 5
// module chunks = 0